var e = [],
  a = e => new RegExp(e.replace(/\*/g, ".*") + "$"),
  r = r => {
    e = r.split(/[\s,]+/).map(a);
  };
var s = function (a, r, s) {
    for (var _len = arguments.length, l = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      l[_key - 3] = arguments[_key];
    }
    for (let n = e.length; n--;) if (e[n].test(a)) return r({
      name: a,
      level: s,
      messages: l
    });
  },
  l = e => {
    let a = "";
    const r = console["fatal" === e.level ? "error" : e.level];
    if (e.name && (a += `[${e.name}] `), "object" == typeof e.messages[0]) r(a, ...e.messages);else {
      r(a + e.messages.shift(), ...e.messages);
    }
  },
  n = (e, a) => ({
    fatal: s.bind(0, e, a = a || l, "fatal"),
    error: s.bind(0, e, a, "error"),
    warn: s.bind(0, e, a, "warn"),
    debug: s.bind(0, e, a, "debug"),
    info: s.bind(0, e, a, "info"),
    log: s.bind(0, e, a, "log")
  }),
  o = n(""),
  t = o.fatal,
  g = o.error,
  i = o.warn,
  f = o.debug,
  b = o.info,
  d = o.log;
export { f as debug, l as default_reporter, n as diary, r as enable, g as error, t as fatal, b as info, d as log, i as warn };